import { render, staticRenderFns } from "./CountryAside.vue?vue&type=template&id=f6678c2c&"
import script from "./CountryAside.vue?vue&type=script&lang=js&"
export * from "./CountryAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports